module.exports = __webpack_public_path__ + "Acceleratorimagea-8028f64e.webp";